<template>
  <div class="c-line-style">
    <el-collapse>
      <el-collapse-item title="绘图区域">
        <style-sub-item title="配色设置">
          <el-form-item>
            <div class="c-line-style-themes">
              <div class="c-line-style-theme" v-for="(item, idx) in dataList" :key="idx">
                <el-color-picker @change="(color)=>handleChange(item, color)"
                  v-model="item[customKey + 'seriesColor']"></el-color-picker>
                <span>{{ item[customKey + 'text'] }}</span>
              </div>
            </div>
          </el-form-item>
        </style-sub-item>
        <el-form-item>
          <div class="chart-form-item-warp">
            <span class="jz-chart-title-label">线条类型</span>
            <el-radio-group v-model="selectItem.styleConfig.commongConfig.lineChartConfig.lineType">
              <el-radio :label="lineTypeMap.curve">曲线</el-radio>
              <el-radio :label="lineTypeMap.line">折线</el-radio>
            </el-radio-group>
          </div>
          <div class="chart-form-item-warp">
            <span class="jz-chart-title-label">线条样式</span>
            <div class="chart-form-item-warp">
              <el-radio-group v-model="selectItem.styleConfig.commongConfig.lineChartConfig.lineStyle">
                <el-radio :label="lineStyleMap.sty1">实线</el-radio>
                <el-radio :label="lineStyleMap.sty2">虚线</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div class="chart-form-item-warp">
            <span class="jz-chart-title-label">线条宽度</span>
              <el-input-number :min="1" :max="10" controls-position="right" v-model="selectItem.styleConfig.commongConfig.lineChartConfig.lineWidth" placeholder="请输入"
                popper-class="c-input-style-popper">
                <template #append>
                  <span>px</span>
                </template>
              </el-input-number>
            </div>
          <div class="chart-form-item-warp">
            <span class="jz-chart-title-label">
              <el-checkbox v-model="selectItem.styleConfig.commongConfig.lineChartConfig.showPoint">显示标记点</el-checkbox>
            </span>
            <el-select v-model="selectItem.styleConfig.commongConfig.lineChartConfig.pointShape" placeholder="请选择"
              popper-class="c-select-style-popper">
              <el-option label="圆形" value="circle"></el-option>
              <el-option label="方形" value="square"></el-option>
              <el-option label="菱形" value="diamond"></el-option>
              <el-option label="六边形" value="hexagon"></el-option>
            </el-select>
          </div>
          <div class="chart-form-item-warp">
            <span class="jz-chart-title-label">空值处理</span>
            <el-radio-group v-model="selectItem.styleConfig.commongConfig.lineChartConfig.emptyValue">
              <el-radio :label="emptyValueMap.skip">直接跨过</el-radio>
              <el-radio :label="emptyValueMap.zero">置为0，不断开</el-radio>
              <el-radio :label="emptyValueMap.disconnect">线条断开</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
      </el-collapse-item>
      <legend-style :config="selectItem.styleConfig.commongConfig.legendConfig"></legend-style>
      <el-collapse-item title="数据标签">
        <el-form-item>
          <div class="chart-form-item-warp">
            <span class="jz-chart-title-label">是否开启</span>
            <el-switch v-model="selectItem.styleConfig.commongConfig.labelConfig.show">
            </el-switch>
          </div>
          <div class="chart-form-item-warp">
            <el-checkbox v-model="selectItem.styleConfig.commongConfig.labelConfig.showAll">全量显示</el-checkbox>
          </div>
          <div class="chart-form-item-warp">
            <span class="jz-chart-title-label">位置</span>
            <el-select v-model="selectItem.styleConfig.commongConfig.labelConfig.position" placeholder="请选择"
              popper-class="c-select-style-popper">
              <el-option label="自动" value=""></el-option>
              <el-option label="上方" value="top"></el-option>
              <el-option label="下方" value="bottom"></el-option>
            </el-select>
          </div>
          <text-style :config="selectItem.styleConfig.commongConfig.labelConfig.textConfig"></text-style>
        </el-form-item>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import styleSubItem from '../base/styleSubItem.vue'
import { transferObjectToArray, getFieldValueByCustomKey } from '../../utils/index'
import { customKey, lineTypeMap, lineStyleMap, emptyValueMap } from '../../utils/enum.data'
import textStyle from '../base/textStyle.vue'
import legendStyle from '../base/legendStyle.vue'
import { updateFieldMapColor } from '../../utils/utils'
export default {    
  name: 'cLineStyle',
  components: {
    styleSubItem,     
    textStyle,
    legendStyle
  },
  props: {
    selectItem: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      getFieldValueByCustomKey,
      customKey,
      lineTypeMap,
      lineStyleMap,
      emptyValueMap,
    }
  },
  computed: {
    dataList() {
      return transferObjectToArray(this.selectItem)
    }
  },
  methods: {
    handleChange(item, color) {
      updateFieldMapColor(this, this.selectItem, item, customKey, color, true)
    },
    formatTooltip(value) {
      return `${value}%`
    }
  }
}
</script>
<style scoped lang="less">
.c-line-style {
  .c-line-style-theme {
    &:not(:first-child) {
      margin-top: 2px;
    }

    display: flex;
    align-items: center;
    margin-bottom: 2px;
    background: #fff;
    padding: 6px 12px;

    span {
      flex: 1;
      text-align: left;
      margin-left: 8px;
    }

    .el-color-picker {
      width: 26px;
    }
  }

  // 暗黑主题样式覆盖
  /deep/ .el-select-dropdown {
    background-color: #2c2f36 !important;
    border: 1px solid #404040 !important;
  }
  
  /deep/ .el-select-dropdown__item {
    background-color: #2c2f36 !important;
    color: #ffffff !important;
    
    &:hover {
      background-color: #404040 !important;
    }
    
    &.selected {
      background-color: #1890ff !important;
      color: #ffffff !important;
    }
  }
  
  /deep/ .el-select-dropdown__empty {
    color: #909399 !important;
  }
}

// 全局样式，用于覆盖 popper 渲染到 body 中的下拉框
</style>